import type { OptionScope } from "@/api/usePolicies.types"
import type { SastGuidanceResponse } from "@/api/useSettings.types"

export const FIELD_NAMES = {
  cwes: "cwes",
  ruleIds: "ruleIds",
  repositoryName: "repositoryName"
} as const

export const useGetSastGuidanceSelector = (
  response: SastGuidanceResponse,
  options: OptionScope[] | undefined
) => {
  const { data, ...rest } = response || {}
  const CWE_LABELS_COUNT = 2

  return {
    data: data?.map((item) => {
      const cwes = item.filters?.cwes || []
      const labels = cwes.slice(0, CWE_LABELS_COUNT).join(", ")
      const items = cwes.slice(CWE_LABELS_COUNT)

      return {
        key: item.id,
        cweIdsMore: {
          items: items,
          label: labels,
          count: items.length,
          id: item.id
        },
        specificResources: Object.entries(item.filters?.scope || {})
          .filter(([_, value]) => Array.isArray(value) && value.length > 0)
          .map(([type, value]) => ({
            type,
            value,
            displayName:
              options?.find((opt) => opt.id === type)?.displayName || type
          })),
        ...item
      }
    }),
    ...rest
  }
}
